{
  "i18n.app.optional": "(optional)",

  "i18n.loadingSpinner.title": "Laden...",

  "i18n.salon.init.error": "Salon Initialisierung fehlgeschlagen",
  "i18n.salon.notReady": "Dieser Salon ist noch nicht bereit.",

  "i18n.activity.price": "Preis",

  "i18n.booking.timezoneNotice": "Zeitslots sind in Zeitzone:",
  "i18n.booking.selectService": "Dienstleistung auswählen",
  "i18n.booking.selectDateTime": "Datum/Uhrzeit auswählen",
  "i18n.booking.guestDetails": "Gastdetails",
  "i18n.booking.reviewAndBook": "Überprüfen & Buchen",
  "i18n.booking.appointmentDetails": "Termindetails",
  "i18n.booking.date": "Datum",
  "i18n.booking.time": "Uhrzeit",
  "i18n.booking.reviewDescription": "Bitte überprüfen Sie Ihre Auswahl und bestätigen Sie Ihre Buchung.",
  "i18n.booking.bookAppointment": "Termin buchen",
  "i18n.booking.confirmation": "Bestätigung",
  "i18n.booking.confirmationDescription": "Ihre Buchung wird bestätigt. Sie erhalten eine Bestätigungs-E-Mail.",
  "i18n.booking.selectSlot": "Wählen Sie einen Slot aus, um einen Termin zu buchen",
  "i18n.booking.noSlotsAvailable": "Keine Termine verfügbar",
  "i18n.booking.noServicesAvailable": "Keine Dienstleistungen verfügbar",
  "i18n.booking.dateIsInPast": "Datum ist in der Vergangenheit",
  "i18n.booking.tooFarInAdvance": "Dieses Datum ist noch nicht für Buchungen verfügbar",
  "i18n.booking.email": "E-Mail",
  "i18n.booking.emailPlaceholder": "ihre.email@beispiel.de",
  "i18n.booking.email.required": "E-Mail ist erforderlich",
  "i18n.booking.email.emailFormat": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  "i18n.booking.email.maxLength": "E-Mail darf maximal 255 Zeichen lang sein",
  "i18n.booking.name": "Name",
  "i18n.booking.namePlaceholder": "Ihr Name",
  "i18n.booking.guestName.maxlength": "Name darf maximal 100 Zeichen lang sein",
  "i18n.booking.phone": "Telefon",
  "i18n.booking.phonePlaceholder": "Ihre Telefonnummer",
  "i18n.booking.guestPhone.maxlength": "Telefonnummer darf maximal 50 Zeichen lang sein",
  "i18n.booking.guestPhone.invalid": "Telefonnummer darf nur Ziffern und die Zeichen + - ( ) . / sowie Leerzeichen enthalten",
  "i18n.booking.comment": "Notiz",
  "i18n.booking.commentPlaceholder": "Fügen Sie besondere Wünsche oder Notizen hinzu...",
  "i18n.booking.comment.maxlength": "Notiz darf maximal 500 Zeichen lang sein",
  "i18n.booking.appointmentWith": "Termin mit",
  "i18n.booking.updateBooking": "Termin aktualisieren",
  "i18n.booking.today": "Heute",
  "i18n.booking.datePicker": "Datumsauswahl",
  "i18n.booking.previousMonth": "Vorheriger Monat",
  "i18n.booking.nextMonth": "Nächster Monat",

  "i18n.bookingDetails.loadingSpinner.subTitle": "Ihre Daten werden geladen",
  "i18n.bookingDetails.title": "Buchungsdetails",
  "i18n.bookingDetails.bookingRef": "Buchungsreferenz",
  "i18n.bookingDetails.guest": "Gast",
  "i18n.bookingDetails.phone": "Telefon",
  "i18n.bookingDetails.email": "E-Mail",
  "i18n.bookingDetails.service": "Dienstleistung",
  "i18n.bookingDetails.date": "Datum",
  "i18n.bookingDetails.time": "Uhrzeit",
  "i18n.bookingDetails.comment": "Notizen",

  "i18n.modalConfirmCancel.title": "Buchung stornieren",
  "i18n.modalConfirmCancel.subtitle": "Möchten Sie diese Buchung wirklich stornieren? Diese Aktion kann nicht rückgängig gemacht werden.",
  "i18n.modalConfirmCancel.confirm": "Ja, Buchung stornieren",
  "i18n.modalConfirmCancel.cancel": "Buchung behalten",

  "i18n.bookingNotFound.notFound.title": "Buchung nicht gefunden",
  "i18n.bookingNotFound.notFound.subtitle": "Diese Buchung konnte nicht gefunden werden. Sie wurde möglicherweise bereits storniert oder der Link ist ungültig.",

  "i18n.cancelBooking.title": "Buchung stornieren",
  "i18n.cancelBooking.subtitle": "Möchten Sie diese Buchung wirklich stornieren?",
  "i18n.cancelBooking.doCancelBooking": "Buchung stornieren",
  "i18n.cancelBooking.notCancellable.title": "Stornierung nicht mehr möglich",
  "i18n.cancelBooking.notCancellable.subtitle": "Die Stornierungsfrist für diese Buchung ist abgelaufen. Bitte kontaktieren Sie den Salon direkt, falls Sie Hilfe benötigen.",
  "i18n.cancelBooking.delete.error": "Buchung konnte nicht storniert werden. Bitte versuchen Sie es erneut.",
  "i18n.cancelBooking.delete.tooLate": "Diese Buchung kann nicht mehr storniert werden.",
  "i18n.cancelBooking.deleted.title": "Buchung storniert",
  "i18n.cancelBooking.deleted.subtitle": "Ihre Buchung wurde erfolgreich storniert.",
  "i18n.cancelBooking.deleted.closePage": "Sie können diese Seite jetzt sicher schliessen.",
  "i18n.booking.notEditable.title": "Buchung nicht mehr bearbeitbar",
  "i18n.booking.notEditable.subtitle": "Die Bearbeitungsfrist für diese Buchung ist abgelaufen. Bitte kontaktieren Sie den Salon direkt, falls Sie Änderungen vornehmen möchten.",
  "i18n.booking.save.conflict": "Dieser Zeitslot ist nicht mehr verfügbar. Bitte wählen Sie einen anderen Termin.",
  "i18n.booking.save.error": "Buchung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  "i18n.booking.load.error": "Buchungsdetails konnten nicht geladen werden. Bitte überprüfen Sie die Buchungsreferenz und versuchen Sie es erneut.",

  "i18n.confirmBooking.title": "Buchung bestätigt!",
  "i18n.confirmBooking.subtitle": "Ihr Termin wurde erfolgreich gebucht. Eine Bestätigungs-E-Mail ist unterwegs.",
  "i18n.confirmBooking.addToCalendarIcs": "Zum Kalender hinzufügen (.ics)",
  "i18n.confirmBooking.addToCalendarGoogle": "Kalender Android/Google",
  "i18n.addToCalendar.with": "Mit",
  "i18n.addToCalendar.guest": "Gast",
  "i18n.addToCalendar.phone": "Telefon",
  "i18n.confirmBooking.newBooking": "Weiteren Termin buchen",
  "i18n.confirmBooking.closePage": "Sie können diese Seite jetzt sicher schliessen. Ihre Buchung wurden gespeichert.",

  "i18n.footer.privacyPolicy": "Datenschutzrichtlinie",
  "i18n.footer.termsOfService": "Nutzungsbedingungen",

  "i18n.signUp.legal.1": "Ich stimme zu, die ",
  "i18n.signUp.legal.2": " und die ",
  "i18n.signUp.legal.3": " einzuhalten",

  "i18n.home.title": "SmallSalon Online-Buchungen",
  "i18n.home.badge": "Online-Buchungsplattform",
  "i18n.home.headline1": "Buchen Sie Ihren nächsten",
  "i18n.home.headline2": "Salon-Termin",
  "i18n.home.headline3": "in Sekunden.",
  "i18n.home.subheadline": "SmallSalon verbindet Sie mit unabhängigen Salons und Solo-Stylisten in Ihrer Nähe. Dienstleistungen entdecken, Termin wählen und bestätigen - ganz ohne Telefonaten.",
  "i18n.home.feature1": "Echtzeit-Verfügbarkeit - immer aktuell",
  "i18n.home.feature2": "Sofortige Bestätigung mit E-Mail-Erinnerungen",
  "i18n.home.feature3": "Jederzeit umbuchen oder stornieren, stressfrei",
  "i18n.home.cta.website": "SmallSalon.io besuchen",
  "i18n.home.cta.register": "Konto erstellen",
  "i18n.home.solo.heading": "Sind Sie Solo-Saloninhaber?",
  "i18n.home.solo.description": "Erhalten Sie Ihre eigene Buchungsseite. Online-Buchungen entgegennehmen, automatische Erinnerungen senden und Ihren Kalender gefüllt halten - alles an einem Ort. Leichtgewichtige Buchungsplattform für Einzelunternehmer.",
  "i18n.home.solo.cta": "Kostenlos starten →",

  "i18n.privacyPolicy.backButton": "← Zurück",
  "i18n.privacyPolicy.title": "Datenschutzrichtlinie",
  "i18n.privacyPolicy.effectiveDate": "Gültig ab:",
  "i18n.privacyPolicy.effectiveDateValue": "1. Juni 2026",
  "i18n.privacyPolicy.intro": "Diese Datenschutzrichtlinie erläutert, wie die Concrete Code GmbH personenbezogene Daten im Zusammenhang mit der kundenseitigen Buchungsanwendung von SmallSalon verarbeitet.",

  "i18n.privacyPolicy.s1.title": "1. Verantwortlicher",
  "i18n.privacyPolicy.s1.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSchweiz",
  "i18n.privacyPolicy.s1.email": "E-Mail: info@smallsalon.io",

  "i18n.privacyPolicy.s2.title": "2. Geltungsbereich",
  "i18n.privacyPolicy.s2.p1": "Diese Datenschutzrichtlinie gilt für Kunden, die die SmallSalon-Buchungsanwendung nutzen, um Saloninformationen abzurufen, Dienstleistungen zu durchsuchen und Termine bei unabhängigen Saloninhabern zu buchen.",
  "i18n.privacyPolicy.s2.p2": "Die SmallSalon-Buchungsanwendung ist ausschliesslich für Nutzer ab 18 Jahren bestimmt.",

  "i18n.privacyPolicy.s3.title": "3. Anwendbares Recht",
  "i18n.privacyPolicy.s3.p1": "Wir verarbeiten personenbezogene Daten gemäss dem schweizerischen Datenschutzrecht und, soweit anwendbar, der Datenschutz-Grundverordnung (DSGVO) der Europäischen Union.",

  "i18n.privacyPolicy.s4.title": "4. Rolle von SmallSalon und Saloninhabern",
  "i18n.privacyPolicy.s4.p1": "Saloninhaber, die SmallSalon nutzen, betreiben unabhängige Unternehmen.",
  "i18n.privacyPolicy.s4.p2": "Saloninhaber sind allein verantwortlich für:",
  "i18n.privacyPolicy.s4.li1": "Ihre Dienstleistungen und deren Qualität",
  "i18n.privacyPolicy.s4.li2": "Preisinformationen",
  "i18n.privacyPolicy.s4.li3": "Öffnungszeiten und Verfügbarkeit",
  "i18n.privacyPolicy.s4.li4": "Buchungs- und Stornierungsrichtlinien",
  "i18n.privacyPolicy.s4.li5": "Ihre Kundenbeziehungen",
  "i18n.privacyPolicy.s4.li6": "Die Nutzung und Verarbeitung von Kundendaten in ihrem Salonbetrieb",
  "i18n.privacyPolicy.s4.p3": "SmallSalon stellt die technische Infrastruktur und Plattform für die Terminbuchung und Kommunikation bereit.",
  "i18n.privacyPolicy.s4.p4": "Saloninhaber agieren als unabhängige Verantwortliche für Kundendaten im Zusammenhang mit ihrem Salonbetrieb und ihren Kundenbeziehungen.",
  "i18n.privacyPolicy.s4.p5": "Kunden müssen sich ggf. direkt an den Saloninhaber wenden bezüglich:",
  "i18n.privacyPolicy.s4.li7": "Terminbezogener Anliegen",
  "i18n.privacyPolicy.s4.li8": "Dienstleistungsstreitigkeiten",
  "i18n.privacyPolicy.s4.li9": "Buchungskorrekturen",
  "i18n.privacyPolicy.s4.li10": "Löschanfragen im Zusammenhang mit Terminen",

  "i18n.privacyPolicy.s5.title": "5. Erhobene personenbezogene Daten",
  "i18n.privacyPolicy.s5.p1": "Bei einer Buchung können folgende personenbezogene Daten erhoben werden:",
  "i18n.privacyPolicy.s5.li1": "Name des Gastes",
  "i18n.privacyPolicy.s5.li2": "E-Mail-Adresse",
  "i18n.privacyPolicy.s5.li3": "Buchungskommentare oder -notizen",
  "i18n.privacyPolicy.s5.li4": "Ausgewählte Dienstleistung oder Aktivität",
  "i18n.privacyPolicy.s5.li5": "Datum und Uhrzeit des Termins",
  "i18n.privacyPolicy.s5.p2": "Telefonnummern werden über die SmallSalon-Buchungsanwendung nicht erhoben.",
  "i18n.privacyPolicy.s5.p3": "E-Mail-Adressen der Kunden sind erforderlich, um buchungsbezogene Mitteilungen zu versenden.",
  "i18n.privacyPolicy.s5.p4": "Buchungskommentare sind auf maximal 250 Zeichen begrenzt.",

  "i18n.privacyPolicy.s6.title": "6. Technische und sicherheitsbezogene Daten",
  "i18n.privacyPolicy.s6.p1": "Für technische, betriebliche und sicherheitsbezogene Zwecke können wir folgende Daten verarbeiten:",
  "i18n.privacyPolicy.s6.li1": "IP-Adressen",
  "i18n.privacyPolicy.s6.li2": "Browser-Informationen",
  "i18n.privacyPolicy.s6.li3": "Geräteinformationen",
  "i18n.privacyPolicy.s6.li4": "Sitzungsbezogene Informationen",
  "i18n.privacyPolicy.s6.li5": "Sicherheits- und technische Protokolle",
  "i18n.privacyPolicy.s6.p2": "Kunden erstellen keine Konten und werden nicht über die Buchungsanwendung authentifiziert.",

  "i18n.privacyPolicy.s7.title": "7. Buchungskommunikation",
  "i18n.privacyPolicy.s7.p1": "SmallSalon kann automatisch folgendes versenden:",
  "i18n.privacyPolicy.s7.li1": "Buchungsbestätigungs-E-Mails",
  "i18n.privacyPolicy.s7.li2": "Terminerinnerungs-E-Mails",
  "i18n.privacyPolicy.s7.li3": "Stornierungsbenachrichtigungen",
  "i18n.privacyPolicy.s7.li4": "Umbuchungsbenachrichtigungen",
  "i18n.privacyPolicy.s7.p2": "E-Mails werden über den Amazon Web Services Simple Email Service (AWS SES) versendet.",
  "i18n.privacyPolicy.s7.p3": "Die Zustellung von E-Mails und Benachrichtigungen kann nicht garantiert werden. E-Mails können durch Drittanbieter verzögert, blockiert, gefiltert oder als Spam eingestuft werden.",

  "i18n.privacyPolicy.s8.title": "8. Stornierung- und Umbuchungsrichtlinien",
  "i18n.privacyPolicy.s8.p1": "Jeder Saloninhaber legt seine eigenen Stornierung- und Änderungsregeln selbstständig fest.",
  "i18n.privacyPolicy.s8.p2": "Es können Änderungsfristen gelten. Nach Ablauf der festgelegten Frist können Buchungen gesperrt und nicht mehr über die Plattform geändert werden.",
  "i18n.privacyPolicy.s8.p3": "Saloninhaber können ihre Stornierung- und Änderungsregeln selbstständig anpassen.",

  "i18n.privacyPolicy.s9.title": "9. Zahlungen",
  "i18n.privacyPolicy.s9.p1": "SmallSalon verarbeitet keine Kundenzahlungen.",
  "i18n.privacyPolicy.s9.p2": "Über die SmallSalon-Buchungsanwendung werden keine Zahlungskarten- oder Bankdaten von Kunden erhoben.",
  "i18n.privacyPolicy.s9.p3": "Zahlungen für Salondienstleistungen werden direkt zwischen dem Kunden und dem Saloninhaber ausserhalb der Plattform abgewickelt.",

  "i18n.privacyPolicy.s10.title": "10. Hosting und Infrastruktur",
  "i18n.privacyPolicy.s10.p1": "SmallSalon wird auf Amazon Web Services (AWS) gehostet, hauptsächlich in der Region eu-central-1.",
  "i18n.privacyPolicy.s10.p2": "Die Plattform nutzt folgende AWS-Dienste:",
  "i18n.privacyPolicy.s10.li1": "CloudFront",
  "i18n.privacyPolicy.s10.li2": "S3",
  "i18n.privacyPolicy.s10.li3": "Lambda",
  "i18n.privacyPolicy.s10.li4": "DynamoDB",
  "i18n.privacyPolicy.s10.li5": "Cognito",
  "i18n.privacyPolicy.s10.p3": "Backups, technische Protokolle und Sicherheitsprotokolle können für Wartung, Diagnose, Sicherheit, Betrugsprävention und Betriebszwecke verarbeitet werden.",

  "i18n.privacyPolicy.s11.title": "11. Cookies",
  "i18n.privacyPolicy.s11.p1": "Die Buchungsanwendung kann notwendige Cookies verwenden für:",
  "i18n.privacyPolicy.s11.li1": "Sitzungsverwaltung",
  "i18n.privacyPolicy.s11.li2": "Spracheinstellungen",
  "i18n.privacyPolicy.s11.li3": "Buchungsprozess-Funktionalität",
  "i18n.privacyPolicy.s11.p2": "Die SmallSalon-Buchungsanwendung verwendet derzeit keine Analyse-Cookies, Werbe-Tracker, Marketing-Pixel oder ähnliche Tracking-Technologien.",

  "i18n.privacyPolicy.s12.title": "12. Drittanbieter und Datenweitergabe",
  "i18n.privacyPolicy.s12.p1": "Personenbezogene Daten können durch Drittanbieter verarbeitet werden, soweit dies für den Betrieb der Plattform erforderlich ist.",
  "i18n.privacyPolicy.s12.p2": "Zu diesen Anbietern gehören:",
  "i18n.privacyPolicy.s12.li1": "Amazon Web Services für Hosting, Speicherung, Infrastruktur und E-Mail-Versand",
  "i18n.privacyPolicy.s12.p3": "Buchungsdaten werden für Terminverwaltungszwecke an den jeweiligen Saloninhaber weitergegeben.",
  "i18n.privacyPolicy.s12.p4": "Wir verkaufen keine personenbezogenen Kundendaten.",
  "i18n.privacyPolicy.s12.p5": "Support- oder Verwaltungspersonal kann auf buchungsbezogene Daten zugreifen, soweit dies für Support, Wartung, Fehlerbehebung, Sicherheit, Betrugsprävention oder die Einhaltung gesetzlicher Vorschriften erforderlich ist.",

  "i18n.privacyPolicy.s13.title": "13. Datenspeicherung",
  "i18n.privacyPolicy.s13.p1": "Buchungsbezogene Daten können bis zu einem Jahr aufbewahrt werden.",
  "i18n.privacyPolicy.s13.p2": "Saloninhaber können Buchungen und kundenbezogene Buchungsdaten selbstständig löschen.",
  "i18n.privacyPolicy.s13.p3": "Wenn ein Saloninhaber sein Konto löscht, können auch zugehörige Buchungsdaten gelöscht werden.",
  "i18n.privacyPolicy.s13.p4": "Backups und bestimmte Sicherheits- oder Betrugsschutzprotokolle können aus technischen, betrieblichen oder rechtlichen Gründen vorübergehend gespeichert bleiben.",

  "i18n.privacyPolicy.s14.title": "14. Sicherheit",
  "i18n.privacyPolicy.s14.p1": "Wir ergreifen angemessene technische und organisatorische Massnahmen zum Schutz personenbezogener Daten.",
  "i18n.privacyPolicy.s14.p2": "Diese Massnahmen können umfassen:",
  "i18n.privacyPolicy.s14.li1": "HTTPS- und TLS-Verschlüsselung",
  "i18n.privacyPolicy.s14.li2": "Verschlüsselte Infrastruktur",
  "i18n.privacyPolicy.s14.li3": "Zugriffskontrollen",
  "i18n.privacyPolicy.s14.li4": "Überwachungssysteme",
  "i18n.privacyPolicy.s14.li5": "Sicherheitsprotokollierung",
  "i18n.privacyPolicy.s14.li6": "Backups",
  "i18n.privacyPolicy.s14.p3": "Kein System kann jedoch absolute Sicherheit garantieren.",

  "i18n.privacyPolicy.s15.title": "15. Ihre Rechte",
  "i18n.privacyPolicy.s15.p1": "Nach geltendem Recht können Kunden folgende Rechte haben:",
  "i18n.privacyPolicy.s15.li1": "Auskunft über personenbezogene Daten",
  "i18n.privacyPolicy.s15.li2": "Berichtigung unrichtiger Daten",
  "i18n.privacyPolicy.s15.li3": "Löschung personenbezogener Daten",
  "i18n.privacyPolicy.s15.li4": "Widerspruch gegen bestimmte Verarbeitungstätigkeiten",
  "i18n.privacyPolicy.s15.li5": "Widerruf der Einwilligung, soweit anwendbar",
  "i18n.privacyPolicy.s15.p2": "Anfragen können eingereicht werden an: info@smallsalon.io",
  "i18n.privacyPolicy.s15.p3": "SmallSalon kann Saloninhaber bei datenschutzrechtlichen Kundenanfragen technisch unterstützen, soweit angemessen.",

  "i18n.privacyPolicy.s16.title": "16. Internationale Datenübermittlungen",
  "i18n.privacyPolicy.s16.p1": "Einige Dienstanbieter können Daten ausserhalb der Schweiz oder des Europäischen Wirtschaftsraums verarbeiten.",
  "i18n.privacyPolicy.s16.p2": "Soweit erforderlich, werden geeignete rechtliche Schutzgarantien wie Standardvertragsklauseln oder andere anerkannte Übertragungsmechanismen eingesetzt.",

  "i18n.privacyPolicy.s17.title": "17. Aktualisierungen dieser Datenschutzrichtlinie",
  "i18n.privacyPolicy.s17.p1": "Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren.",
  "i18n.privacyPolicy.s17.p2": "Die weitere Nutzung der SmallSalon-Buchungsanwendung nach Inkrafttreten von Änderungen gilt als Zustimmung zur aktualisierten Datenschutzrichtlinie.",

  "i18n.privacyPolicy.s18.title": "18. Anwendbares Recht",
  "i18n.privacyPolicy.s18.p1": "Diese Datenschutzrichtlinie unterliegt dem schweizerischen Recht.",

  "i18n.privacyPolicy.s19.title": "19. Kontakt",
  "i18n.privacyPolicy.s19.p1": "Für datenschutzbezogene Fragen oder Anfragen wenden Sie sich bitte an:",
  "i18n.privacyPolicy.s19.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSchweiz",
  "i18n.privacyPolicy.s19.email": "E-Mail: info@smallsalon.io",

  "i18n.tos.backButton": "← Zurück",
  "i18n.tos.title": "Buchungsbedingungen",
  "i18n.tos.effectiveDate": "Gültig ab:",
  "i18n.tos.effectiveDateValue": "1. Juni 2026",
  "i18n.tos.intro1": "Diese Buchungsbedingungen («Bedingungen») regeln die Nutzung der SmallSalon-Buchungsplattform durch Kunden, die Termine bei unabhängigen Saloninhabern buchen.",
  "i18n.tos.intro2": "Durch eine Buchung über SmallSalon stimmen Sie diesen Bedingungen zu.",

  "i18n.tos.s1.title": "1. Betreiberinformationen",
  "i18n.tos.s1.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSchweiz",
  "i18n.tos.s1.contact": "Kontakt: info@smallsalon.io",

  "i18n.tos.s2.title": "2. Zweck der Plattform",
  "i18n.tos.s2.p1": "SmallSalon ermöglicht es Kunden, Termine bei unabhängigen Saloninhabern zu buchen.",
  "i18n.tos.s2.p2": "Kunden können Termine buchen, ohne ein Kundenkonto zu erstellen.",
  "i18n.tos.s2.p3": "SmallSalon stellt die technische Plattform für die Terminbuchung und Kommunikation bereit.",
  "i18n.tos.s2.p4": "SmallSalon garantiert keine Terminverfügbarkeit.",

  "i18n.tos.s3.title": "3. Verhältnis zwischen Kunden und Saloninhabern",
  "i18n.tos.s3.p1": "Der Buchungsvertrag besteht ausschliesslich zwischen dem Kunden und dem Saloninhaber.",
  "i18n.tos.s3.p2": "SmallSalon und Concrete Code GmbH:",
  "i18n.tos.s3.p2list": "- sind keine Salons\n- beschäftigen keine Saloninhaber\n- beaufsichtigen keine Saloninhaber\n- sind nicht für Salondienstleistungen verantwortlich",
  "i18n.tos.s3.p3": "Saloninhaber tragen die volle und alleinige Verantwortung für:",
  "i18n.tos.s3.p3list": "- Dienstleistungsbeschreibungen\n- Preisinformationen\n- Zeitpläne und Verfügbarkeit\n- hochgeladene Bilder und Inhalte\n- Dienstleistungsqualität\n- Terminerfüllung\n- Stornierungen und Umbuchungen\n- Hygienestandards\n- Einhaltung gesetzlicher und behördlicher Vorschriften",
  "i18n.tos.s3.p4": "Concrete Code GmbH und SmallSalon sind nicht verantwortlich für ungenaue, irreführende, veraltete, unvollständige oder rechtswidrige Informationen, die von Saloninhabern hochgeladen oder bereitgestellt werden.",

  "i18n.tos.s4.title": "4. Zahlungen",
  "i18n.tos.s4.p1": "SmallSalon verarbeitet keine Zahlungen zwischen Kunden und Saloninhabern.",
  "i18n.tos.s4.p2": "Zahlungen für Salondienstleistungen werden direkt zwischen dem Kunden und dem Saloninhaber abgewickelt, in der Regel vor Ort im Salon.",
  "i18n.tos.s4.p3": "Concrete Code GmbH und SmallSalon sind nicht verantwortlich für:",
  "i18n.tos.s4.p3list": "- Zahlungsstreitigkeiten\n- Rückerstattungen\n- Preismeinungsverschiedenheiten\n- fehlgeschlagene oder strittige Transaktionen zwischen Kunden und Salons",

  "i18n.tos.s5.title": "5. Buchungsregeln und Stornierungsrichtlinien",
  "i18n.tos.s5.p1": "Saloninhaber können Termine nach eigenem Ermessen stornieren oder verschieben.",
  "i18n.tos.s5.p2": "Kunden können Termine gemäss der individuellen Stornierungsrichtlinie des Salons stornieren oder ändern.",
  "i18n.tos.s5.p3": "Jeder Salon legt seine eigene Änderungsfrist fest, die bestimmt, wie weit im Voraus Kunden Termine stornieren oder ändern können.",
  "i18n.tos.s5.p4": "Änderungsfristen liegen in der Regel zwischen 0 und 48 Stunden vor dem geplanten Termin.",
  "i18n.tos.s5.p5": "Nach Ablauf der Änderungsfrist können Buchungen gesperrt und nicht mehr über die Plattform geändert werden.",
  "i18n.tos.s5.p6": "Kunden sind dafür verantwortlich, die Stornierungsrichtlinie des gewählten Salons vor der Buchung zu prüfen.",
  "i18n.tos.s5.p7": "Saloninhaber können ihre Stornierungsrichtlinien jederzeit aktualisieren, wobei Änderungen für zukünftige Buchungsänderungen gelten.",
  "i18n.tos.s5.p8": "Versäumte Termine und Nichterscheinen liegen in der alleinigen Verantwortung des Kunden und des Saloninhabers.",

  "i18n.tos.s6.title": "6. Pflichten der Kunden",
  "i18n.tos.s6.p1": "Kunden verpflichten sich, genaue und vollständige Buchungsinformationen anzugeben.",
  "i18n.tos.s6.p2": "Betrügerische, missbräuchliche, irreführende, gefälschte oder Spam-Buchungen sind streng verboten.",
  "i18n.tos.s6.p3": "Kunden sind dafür verantwortlich, dass ihre Kontaktdaten korrekt und erreichbar sind.",
  "i18n.tos.s6.p4": "Concrete Code GmbH und SmallSalon behalten sich das Recht vor, den Zugang für Nutzer zu sperren oder einzuschränken, die die Plattform missbrauchen.",

  "i18n.tos.s7.title": "7. Benachrichtigungen und Kommunikation",
  "i18n.tos.s7.p1": "SmallSalon kann Buchungsbestätigungen, Erinnerungen, Stornierungshinweise und andere betriebliche Mitteilungen zu Terminen senden.",
  "i18n.tos.s7.p2": "Concrete Code GmbH und SmallSalon sind nicht verantwortlich für fehlgeschlagene, verzögerte, gefilterte, blockierte oder nicht zugestellte Benachrichtigungen, einschliesslich E-Mails, die als Spam eingestuft oder anderweitig nicht empfangen werden.",

  "i18n.tos.s8.title": "8. Plattformverfügbarkeit",
  "i18n.tos.s8.p1": "SmallSalon wird «wie besehen» und «wie verfügbar» bereitgestellt.",
  "i18n.tos.s8.p2": "Concrete Code GmbH garantiert keine ununterbrochene Verfügbarkeit der Plattform.",
  "i18n.tos.s8.p3": "Die Plattform kann gelegentlich aufgrund von Wartungsarbeiten, Updates, technischen Problemen oder externen Faktoren nicht verfügbar sein.",
  "i18n.tos.s8.p4": "Concrete Code GmbH behält sich das Recht vor, Funktionen oder Teile der Plattform jederzeit zu ändern, auszusetzen oder einzustellen.",

  "i18n.tos.s9.title": "9. Datenschutz und Kundendaten",
  "i18n.tos.s9.p1": "Buchungsbezogene Kundendaten werden zum Zweck der Terminverwaltung an den Saloninhaber weitergegeben.",
  "i18n.tos.s9.p2": "Nach der Buchung können Saloninhaber Kundendaten eigenständig gemäss ihren eigenen Datenschutzpraktiken und gesetzlichen Verpflichtungen verarbeiten.",
  "i18n.tos.s9.p3": "Saloninhaber sind separat für die Einhaltung der geltenden Datenschutzgesetze verantwortlich.",
  "i18n.tos.s9.p4": "Die Nutzung der Plattform unterliegt ebenfalls der Datenschutzrichtlinie.",

  "i18n.tos.s10.title": "10. Geistiges Eigentum",
  "i18n.tos.s10.p1": "Die SmallSalon-Plattform, Software, Marken, Design und damit verbundenes geistiges Eigentum sind Eigentum der Concrete Code GmbH.",
  "i18n.tos.s10.p2": "Kunden dürfen nicht:",
  "i18n.tos.s10.p2list": "- die Plattform kopieren oder reproduzieren\n- die Plattform zurückentwickeln\n- die Plattform missbrauchen oder zweckentfremden\n- unbefugten Zugriff auf Systeme oder Daten versuchen",

  "i18n.tos.s11.title": "11. Haftungsausschluss",
  "i18n.tos.s11.p1": "Im grösstmöglichen gesetzlich zulässigen Umfang haften Concrete Code GmbH und SmallSalon nicht für:",
  "i18n.tos.s11.p1list": "- Salondienstleistungen oder deren Qualität\n- Verletzungen oder allergische Reaktionen\n- Unzufriedenheit mit Salondienstleistungen\n- versäumte Termine\n- ungenaue Preisangaben\n- ungenaue Dienstleistungsbeschreibungen\n- Kundenstreitigkeiten\n- verlorenes oder beschädigtes Eigentum\n- Betriebsunterbrechungen\n- Entscheidungen oder Handlungen von Saloninhabern",
  "i18n.tos.s11.p2": "Die Nutzung der Plattform erfolgt auf eigenes Risiko.",

  "i18n.tos.s12.title": "12. Höhere Gewalt",
  "i18n.tos.s12.p1": "Concrete Code GmbH haftet nicht für Verzögerungen, Unterbrechungen oder Ausfälle, die durch Umstände ausserhalb der angemessenen Kontrolle verursacht werden, einschliesslich, aber nicht beschränkt auf Naturkatastrophen, Internetausfälle, Cyberangriffe, Stromausfälle, behördliche Massnahmen, Kriege, Arbeitsstreitigkeiten oder Ausfälle von Drittanbietern.",

  "i18n.tos.s13.title": "13. Unabhängige Salonunternehmen",
  "i18n.tos.s13.p1": "Alle Salons, die SmallSalon nutzen, betreiben unabhängige Unternehmen.",
  "i18n.tos.s13.p2": "Einzelne Salons können eigene Richtlinien, Stornierungsregeln, Preisstrukturen und Betriebsverfahren haben.",
  "i18n.tos.s13.p3": "Kunden sollten salonspezifische Informationen sorgfältig prüfen, bevor sie eine Buchung vornehmen.",

  "i18n.tos.s14.title": "14. Änderungen dieser Bedingungen",
  "i18n.tos.s14.p1": "Concrete Code GmbH kann diese Bedingungen von Zeit zu Zeit aktualisieren oder ändern.",
  "i18n.tos.s14.p2": "Die weitere Nutzung der Plattform nach Inkrafttreten der aktualisierten Bedingungen gilt als Zustimmung zu den überarbeiteten Bedingungen.",

  "i18n.tos.s15.title": "15. Salvatorische Klausel",
  "i18n.tos.s15.p1": "Sollte eine Bestimmung dieser Bedingungen für ungültig oder nicht durchsetzbar befunden werden, bleiben die übrigen Bestimmungen vollständig gültig und durchsetzbar.",

  "i18n.tos.s16.title": "16. Anwendbares Recht",
  "i18n.tos.s16.p1": "Diese Bedingungen unterliegen dem Recht der Schweiz.",
  "i18n.tos.s16.p2": "Alle Streitigkeiten aus der Nutzung von SmallSalon unterliegen der Zuständigkeit der zuständigen Gerichte der Schweiz.",

  "i18n.tos.s17.title": "17. Kontakt",
  "i18n.tos.s17.p1": "Für rechtliche, datenschutzbezogene oder plattformbezogene Fragen können Sie uns kontaktieren:",
  "i18n.tos.s17.contact": "Concrete Code GmbH\ninfo@smallsalon.io"
}
